module.exports = __webpack_public_path__ + "static/newstorecen-36c7c69194ae68dbd127179fa0e6f82c.jpg";